import { render, staticRenderFns } from "./PluginPasswordProtection.vue?vue&type=template&id=6728a3a2"
import script from "./PluginPasswordProtection.vue?vue&type=script&lang=js"
export * from "./PluginPasswordProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6728a3a2')) {
      api.createRecord('6728a3a2', component.options)
    } else {
      api.reload('6728a3a2', component.options)
    }
    module.hot.accept("./PluginPasswordProtection.vue?vue&type=template&id=6728a3a2", function () {
      api.rerender('6728a3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginPasswordProtection.vue"
export default component.exports